import React from 'react';
import createFragment from 'react-addons-create-fragment';

const ContentHeader = (props) => {
  return (
    <div className="ma5 flex">
      <div className="fg1">
        {props.children}
      </div>

      <div className="flex negative-mr1-l">
        {createFragment({
          links: props.links.map(link =>
            <div className="pr1-l">{link}</div>)
        })}
      </div>
    </div>
  )
}

ContentHeader.defaultProps = {
  links: null
}


export default ContentHeader;


/** WEBPACK FOOTER **
 ** ./src/components/ContentHeader.js
 **/